import { useState, useEffect } from "react";
import axios from "axios";
import { fastGetAsync } from "../lib/fastFetch";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
function fmt$(v, d = 2) { if (v == null) return "$0.00"; const n = Number(v); if (Math.abs(n) >= 1e6) return "$" + (n / 1e6).toFixed(1) + "M"; if (Math.abs(n) >= 1e3) return "$" + (n / 1e3).toFixed(1) + "K"; return "$" + n.toFixed(d); }
function parseOCC(sym) { const m = sym?.match(/^([A-Z]+)(\d{2})(\d{2})(\d{2})([CP])(\d{8})$/); if (!m) return null; const [, ticker, yy, mm, dd, cp, rawStrike] = m; return { ticker, strike: parseInt(rawStrike, 10) / 1000, side: cp === "C" ? "Call" : "Put", expDate: `${parseInt(mm)}/${parseInt(dd)}/${yy}` }; }

export default function TradeHistoryCard() {
  const [trades, setTrades] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/trades/sync`),
      fastGetAsync(`${API}/daily-pnl?period=month`),
    ]).then(([, pnlRes]) => {
      setTrades(pnlRes.data?.periodTrades || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const totalPnl = trades.reduce((s, t) => s + (t.pnl || 0), 0);
  const wins = trades.filter(t => t.won).length;
  const usdTrades = trades.filter(t => t.currency === "USD");
  const ziTrades = trades.filter(t => t.currency === "ZI");
  const usdPnl = usdTrades.reduce((s, t) => s + (t.pnl || 0), 0);
  const ziPnl = ziTrades.reduce((s, t) => s + (t.pnl || 0), 0);

  return (
    <div className="card" style={{ borderColor: "rgba(74,222,128,0.15)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
        <div className="sh" style={{ margin: 0 }}>Trade History <span className="tag t-bull" style={{ fontSize: 7 }}>ALL SOURCES</span></div>
        {trades.length > 0 && (
          <div style={{ display: "flex", gap: 10, fontSize: 10 }}>
            <span style={{ color: "var(--muted)" }}>{trades.length} trades</span>
            <span className={totalPnl >= 0 ? "pos" : "neg"} style={{ fontWeight: 600 }}>{totalPnl >= 0 ? "+" : ""}{fmt$(totalPnl)}</span>
            <span style={{ color: "var(--muted)" }}>{wins}W/{trades.length - wins}L</span>
          </div>
        )}
      </div>
      {trades.length > 0 && (usdTrades.length > 0 || ziTrades.length > 0) && (
        <div style={{ display: "flex", gap: 14, marginBottom: 10, padding: "8px 12px", borderRadius: 8, background: "var(--layer2)" }}>
          <div style={{ flex: 1, borderRight: "1px solid var(--border)", paddingRight: 14 }}>
            <div style={{ fontSize: 9, color: "var(--muted)", marginBottom: 2, display: "flex", alignItems: "center", gap: 4 }}><span style={{ padding: "1px 4px", borderRadius: 3, fontSize: 7, fontWeight: 700, background: "rgba(74,222,128,0.15)", color: "#4ade80" }}>USD</span> Real ROI</div>
            <div className={usdPnl >= 0 ? "pos" : "neg"} style={{ fontSize: 16, fontWeight: 700 }}>{usdPnl >= 0 ? "+" : ""}{fmt$(usdPnl)}</div>
            <div style={{ fontSize: 9, color: "var(--dim)" }}>{usdTrades.length} trades | {usdTrades.filter(t => t.won).length}W/{usdTrades.filter(t => !t.won).length}L</div>
          </div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 9, color: "var(--muted)", marginBottom: 2, display: "flex", alignItems: "center", gap: 4 }}><span style={{ padding: "1px 4px", borderRadius: 3, fontSize: 7, fontWeight: 700, background: "rgba(167,139,250,0.15)", color: "#a78bfa" }}>z$</span> AI Paper ROI</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: "#a78bfa" }}>{ziPnl >= 0 ? "+" : ""}{fmt$(ziPnl)}</div>
            <div style={{ fontSize: 9, color: "var(--dim)" }}>{ziTrades.length} trades | {ziTrades.filter(t => t.won).length}W/{ziTrades.filter(t => !t.won).length}L</div>
          </div>
        </div>
      )}
      {loading ? (
        <div style={{ textAlign: "center", padding: 20, color: "var(--dim)", fontSize: 11 }}><span className="spin" /> Syncing trade history...</div>
      ) : trades.length === 0 ? (
        <div style={{ textAlign: "center", padding: 20, color: "var(--dim)", fontSize: 12 }}>No trade history found.</div>
      ) : (
        <div style={{ maxHeight: 300, overflowY: "auto" }}>
          {trades.map((t, i) => {
            const occ = parseOCC(t.symbol);
            return (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 10px", borderBottom: "0.5px solid var(--divider)", fontSize: 11 }}>
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                  <span style={{ width: 7, height: 7, borderRadius: "50%", background: t.won ? "#4ade80" : "#f87171", flexShrink: 0 }} />
                  {t.currency === "USD" ? <span style={{ padding: "1px 5px", borderRadius: 3, fontSize: 7, fontWeight: 700, background: "rgba(74,222,128,0.15)", color: "#4ade80", border: "1px solid rgba(74,222,128,0.2)", flexShrink: 0 }}>USD</span>
                  : t.currency === "ZI" ? <span style={{ padding: "1px 5px", borderRadius: 3, fontSize: 7, fontWeight: 700, background: "rgba(167,139,250,0.15)", color: "#a78bfa", border: "1px solid rgba(167,139,250,0.2)", flexShrink: 0 }}>z$</span> : null}
                  <span style={{ fontWeight: 600 }}>{occ ? `${occ.ticker} $${occ.strike}${occ.side[0]}` : (t.symbol || "—")}</span>
                  <span style={{ color: "var(--dim)", fontSize: 10, maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{t.description}</span>
                  {t.source === "omega_ai" && <span className="tag t-pur" style={{ fontSize: 6 }}>OMEGA AI</span>}
                  {t.source === "public.com" && <span className="tag t-blue" style={{ fontSize: 6 }}>PUBLIC.COM</span>}
                </div>
                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                  <span className={t.pnl >= 0 ? "pos" : "neg"} style={{ fontWeight: 600 }}>{t.pnl >= 0 ? "+" : ""}{fmt$(t.pnl)}</span>
                  <span style={{ fontSize: 9, color: "var(--dim)" }}>{t.closedAt ? new Date(t.closedAt).toLocaleDateString() : ""}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
